import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '../scss/vuetify/overrides.scss';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';

import {nl, en} from 'vuetify/locale'

const primitiveColors = {
    // neutrals
    'neutral-100': '#FFFFFF',
    'neutral-200': '#F6F6F6',
    'neutral-300': '#E8E8E8',
    'neutral-400': '#C6C6C6',
    'neutral-500': '#A0A0A0',
    'neutral-600': '#7F7F7F',
    'neutral-700': '#454545',
    'neutral-800': '#333333',
    'neutral-900': '#292929',
    'neutral-1000': '#000000',

    // greens
    'greens-100': '#E3EBEC',
    'greens-200': '#B1CCCF',
    'greens-300': '#8BB3B8',
    'greens-400': '#559097',
    'greens-500': '#357A83',
    'greens-600': '#025964',
    'greens-700': '#02515B',
    'greens-800': '#013F47',
    'greens-900': '#013137',
    'greens-1000': '#01252A',

    // systems
    'system-success': '#14CB8E',
    'on-system-success': '#FFFFFF',
    'system-error': '#CD3439',
    'system-warning': '#F77D03',

    // additional
    'secondary-hover': '#3BC175CC',
    'primary-hover': '#6C3987CC',
    'tertiary-hover': '#F5E7F5CC',
    'disabled-background': '#E7E7E7CC',
    'neutral-alpha-80': '#FFFFFFCC',
}

const defaults = {
    global: { baseColor: 'primary' },
    VSwitch: { baseColor: primitiveColors['neutral-400'], color: primitiveColors['system-success'] },
    VDialog: { persistent: true },
    VBtn: { baseColor: null },
    VListItem: { baseColor: null },
    VDataTable: {
        headerProps: {
            class: 'sm-bold',
            style: 'color: #8A94A6;'
        }
    },
    VContainer: {
        style: {
            backgroundColor: 'rgb(var(--v-theme-secondary))'
        }
    },
    VProgressLinear: {
        color: primitiveColors['greens-600']
    }
};

export default createVuetify({
    components,
    directives,
    defaults,
    icons: {
        defaultSet: 'mdi',
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    ...primitiveColors,
                    secondary: primitiveColors['neutral-200'],
                    hover: primitiveColors['greens-600'],
                    active: primitiveColors['greens-200'],
                    success: primitiveColors['system-success'],
                    error: primitiveColors['system-error'],
                    primary: primitiveColors['greens-500'],
                    alternative: primitiveColors['neutral-100'],
                    selected: primitiveColors['greens-100'],
                    page: primitiveColors['greens-100'],
                    icon: primitiveColors['greens-800'],
                    tertiary: primitiveColors['greens-100'],
                },
            },
        },
    },
    locale: {
        locale: 'nl',
        fallbackLocale: 'en',
        messages: {
            nl,
            en,
        },
    },
});
